import { jsx as _jsx } from "react/jsx-runtime";
export default function Button({ variant = 'primary', children, className = '', ...props }) {
    const baseStyles = 'px-6 py-3 rounded-lg font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
    const variants = {
        primary: 'bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500',
        secondary: 'bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500',
        ghost: 'bg-transparent border-2 border-primary-600 text-primary-600 hover:bg-primary-50 focus:ring-primary-500',
    };
    return (_jsx("button", { className: `${baseStyles} ${variants[variant]} ${className}`, ...props, children: children }));
}
